import React from 'react'
import CartSidebar from './CartSidebar/CartSidebar'
import Classes from './Cart.module.css'
import { Helmet } from 'react-helmet-async'

export default function CartPage({ setopenCart }) {
    return (
        <>
            <Helmet>
                <title>My Cart | luxaywear</title>
                <meta name="description" content="My Cart to checkout all products after filling the billing details." />
                <meta name="robots" content="index, follow" />
                <link rel="canonical" href="https://luxaywear.com/cart" />
            </Helmet>
            <div className={Classes.hero} >
                <CartSidebar setopenCart={setopenCart} />
            </div>
        </>
    )
}
